import WhyShopBabylist from './why-shop-babylist'

export default WhyShopBabylist
